// extracted by mini-css-extract-plugin
module.exports = {"teamIcon":"team-icon_teamIcon___ohgA"};